export interface Connections {
  id: string;
  connectionName: string;
  connectionTypeId: string;
  connectionTypeKey: string;
  connectionTypeDescription: string;
  ipAddress: string;
  username: string;
  password: string;
  port: number;
  folder: string;
  senderName: string;
  address: string;
  clientId: string;
  clientSecret: string;
  fileName: string;
  explicitEncryptionMode: boolean;
}
